import { reviews } from "@/mocks/works";
import SectionHeading from "./SectionHeading";

const avatarColors = [
  "bg-primary-500",
  "bg-accent-500",
  "bg-secondary-500",
  "bg-primary-700",
  "bg-accent-700",
  "bg-secondary-700",
];

export default function Reviews() {
  return (
    <section id="reviews" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="同好口碑"
          title="真实同好的走心评价"
          desc="来自社区同好的真实反馈，不掺水、不夸张。看看大家是怎么被这些作品打动，再决定要不要入坑。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r, idx) => (
            <article
              key={r.id}
              className="relative flex flex-col rounded-2xl bg-background-100 p-6 ring-1 ring-background-200/80"
            >
              <i className="ri-double-quotes-l absolute right-5 top-5 text-3xl text-primary-200" aria-hidden="true"></i>
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-full font-heading text-base font-bold text-background-50 ${avatarColors[idx % avatarColors.length]}`}
                >
                  {r.user.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{r.user}</p>
                  <p className="text-xs text-foreground-500">看过《{r.work}》</p>
                </div>
              </div>

              <div className="mt-4 flex items-center gap-1" aria-label={`${r.rating} 星评价`}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < r.rating ? "ri-star-fill text-accent-500" : "ri-star-line text-background-300"}`}
                    aria-hidden="true"
                  ></i>
                ))}
              </div>

              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{r.content}</p>

              <div className="mt-5 flex items-center justify-between border-t border-background-200/80 pt-3">
                <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {r.date}
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-500">
                  <i className="ri-thumb-up-line" aria-hidden="true"></i>
                  {r.helpful} 人觉得有用
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}